/** Sample content for the Teams page layout. Not connected to APIs. */

export const workspacePreview = {
    name: "UpNComer Records",
    accountType: "Organization",
    ownerName: "Rahul Verma",
    ownerEmail: "rahul@upncomer.com",
    userCount: 4,
    artistCount: 3,
    monthlyTotal: 67,
    nextRenewal: "May 15, 2025",
};

export const artistPreview = [
    {
        id: "karan",
        name: "Karan",
        initials: "K",
        avatarClass: "bg-[#FA6138]",
        seatType: "Base Artist",
        price: 27,
        status: "active",
        creditsRemaining: 8,
        creditsTotal: 50,
        renewsOn: "May 01, 2025",
        cycle: "Monthly",
    },
    {
        id: "khalau",
        name: "Khalau",
        initials: "KH",
        avatarClass: "bg-[#5B4DFF]",
        seatType: "Additional Artist",
        price: 20,
        status: "active",
        creditsRemaining: 50,
        creditsTotal: 50,
        renewsOn: "May 15, 2025",
        cycle: "Monthly",
    },
    {
        id: "meera",
        name: "Meera",
        initials: "M",
        avatarClass: "bg-[#E85AA0]",
        seatType: "Additional Artist",
        price: 20,
        status: "pending_removal",
        activeUntil: "May 28, 2025",
        creditsRemaining: 18,
        creditsTotal: 50,
        renewsOn: "May 28, 2025",
        cycle: "Monthly",
    },
];

export const permissionPreview = [
    { key: "team", label: "Manage team" },
    { key: "artists", label: "Manage artists" },
    { key: "billing", label: "Manage billing" },
    { key: "financials", label: "View financials" },
    { key: "growth", label: "Growth Engine" },
    { key: "links", label: "Links and Fan Hub" },
];

export const memberPreview = [
    {
        id: "rahul",
        name: "Rahul Verma",
        email: "rahul@upncomer.com",
        initials: "RV",
        avatarClass: "bg-[#3D7EFF]",
        role: "SuperAdmin",
        status: "active",
        joined: "Apr 12, 2024",
        lastActive: "Today",
    },
    {
        id: "ananya",
        name: "Ananya Singh",
        email: "ananya@upncomer.com",
        initials: "AS",
        avatarClass: "bg-[#2FBF71]",
        role: "Admin",
        status: "active",
        joined: "Apr 18, 2024",
        lastActive: "2h ago",
    },
    {
        id: "vikram",
        name: "Vikram Kapoor",
        email: "vikram@upncomer.com",
        initials: "VK",
        avatarClass: "bg-[#7A5CFF]",
        role: "Member",
        status: "active",
        joined: "May 02, 2024",
        lastActive: "1d ago",
    },
    {
        id: "neha",
        name: "Neha Patel",
        email: "neha@upncomer.com",
        initials: "NP",
        avatarClass: "bg-[#FA6138]",
        role: "Member",
        status: "invited",
        joined: "May 12, 2025",
        lastActive: "—",
    },
];
